<template>
	<div class="row mt-2">
		<div class="col-sm-12">
			<h4 class="card-title text-center mt-3">
				Redes sociales {{ tipo == 2 ? categoria.descripcion : '' }}
				<a href="#" @click.prevent="limpiar" class="btn btn-danger btn-sm mr-sm-1 float-right" :disabled="btnGuardar">
					<i class="fas fa-plus"></i> Nuevo
				</a>
			</h4>
		</div>
		<div class="col-sm-12" v-show="verForm">
			<div class="card">
				<div class="card-body">
					<form @submit.prevent="guardar">
						<div class="form-group form-group-sm">
							<label for="selectRedsocial" class="mb-0">Red social <span class="text-danger">*</span></label>
							<select id="selectRedSocial" class="custom-select" required v-model="form.red_social_id">
								<option :value="r.id" v-for="r in catalogo.red_social" :key="r.id">{{ r.nombre }}</option>
							</select>
						</div>
						<div class="form-group form-group-sm">
							<label for="inputCuenta" class="mb-0">Cuenta <span class="text-danger">*</span></label>
							<div class="input-group mb-3">
								<div class="input-group-prepend">
									<span class="input-group-text" id="input-cuenta-addon3">{{url}}</span>
								</div>
								<input type="text" class="form-control" id="inputCuenta" aria-describedby="input-cuenta-addon3" v-model="form.cuenta" required>
							</div>
						</div>
						<div class="form-group form-group-sm" v-if="reg != ''">
							<div class="checkbox">
								<label>
									<input type="checkbox" v-model="form.anulado" :true-value="1" :false-value="0"> Anulado
								</label>
							</div>
						</div>
						<div class="form-group form-group-sm">
              <div class="col-sm-12 text-right px-0">
                <button type="submit" class="btn btn-md btn-primary" :disabled="btnGuardar">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    v-if="btnGuardar"
                  ></span>
                  <span class="sr-only" v-if="btnGuardar">Guardando...</span>
                  <span v-else>
										<i class="fas fa-save"></i> Guardar
                  </span>
                </button>
              </div>
            </div>
					</form>
				</div>
			</div>
		</div>
		<div class="col-sm-12">
			<div class="table-responsive">
				<table class="table table-bordered table-sm">
					<thead>
						<tr>
							<th>#</th>
							<th>Red Social</th>
							<th>Cuenta</th>
							<th>Usuario</th>
							<th width="125">Demo enlace</th>
						</tr>
					</thead>
					<tbody>
						<tr v-if="inicio">
							<th colspan="100%" class="text-center">
								<div class="spinner-border" role="status">
									<span class="sr-only">Cargando...</span>
								</div>
							</th>
						</tr>
						<template v-for="(r, idx) in filtrada" v-else>
							<tr v-if="r.anulado == 0" :key="idx">
								<td>{{ idx+1 }}</td>
								<td>
									<a href="#" @click.prevent="editar(idx)">
										{{ r.nombre }}
									</a>
								</td>
								<td>{{ r.cuenta }}</td>
								<td>{{ r.nusuario }}</td>
								<td class="text-center">
									<a 
										:href="r.enlace + r.cuenta" 
										:title="r.nombre"
										target="_blank"
									>
										<span 
											class="badge badge-secondary red-social-bazar"
											:style="{'background': r.color}"
										>
											<i :class="r.icono"></i>
										</span>
									</a>
								</td>
							</tr>
						</template>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
	import ManteAccion from '../mixins/ManteAccion.js';
	import CartaCatalogo from '../mixins/CartaCatalogo.js';
	import axios from 'axios';

	export default {
		name: 'ManteBazarRedes',
		mixins: [ManteAccion, CartaCatalogo],
		props: {
			tipo: {
				type: Number,
				required: false,
				default: 1
			},
			categoria: {
				type: Object, 
				required: false
			}
		},
		data: () => ({
			autoBuscar: false,
			url: '',
			verForm: false
		}),
		created() {
			if (this.tipo == 1) {
				this.nombre = 'bazar_red_social'
			} else {
				this.nombre = 'bazar_proveedor_red_social'
			}

			this.buscar()
			this.getCatalogo(["red_social"])
		},
		methods: {
			buscar () {
				let params = {}
				if (this.tipo == 2) {
					params["carta_categoria_id"] = this.categoria.id
				}
					
				params['lista'] = [this.nombre]

				if (this.tipo == 1 || (this.tipo == 2 && this.categoria)) {
					axios
					.get(this.UrlBase+'/catalogo/get_lista?format=json', {params: params})
					.then(r => {
						this.inicio = false;
						if (r.data.exito) {
							this.lista = r.data.lista[this.nombre];
						} else {
							alert(r.data.mensaje);
						}
					})
					.catch(e => {
						this.inicio = false;
						alert(e);
					});
				}
			},
			limpiar () {
				this.reg = '';
				this.form = {};
				if (this.tipo == 2) {
					this.form = {
						carta_categoria_id: this.categoria.id
					}
				}
				this.verForm = true
			},
		},
		watch: {
			'form.red_social_id'(red) {
				this.url = ''
				if (red) {
					let tmp = this.catalogo.red_social.filter(rs => rs.id == red)
					if (tmp[0]) {
						this.url = tmp[0].enlace
					}
				}
			},
			categoria(nuevo) {
				this.lista = []
				if (nuevo) {
					this.buscar()
				}
			}
		}
	}
</script>

<style>
.red-social-bazar {
  padding: 7.5px;
  border-radius: 50%;
  margin: 0 1.5px;
}
</style>